import { AxiosInstance } from '../../../utilities/requestClient';
import type { MarketsOverviewPageModel, YieldCurvePageModel } from './types';

/** GET /markets-overview/:selectedDate — markets overview (`PageModel` envelope). */
export const getMarketsOverview = async (
  selectedDate: string,
): Promise<MarketsOverviewPageModel> => {
  const { data } = await AxiosInstance.get<MarketsOverviewPageModel>(
    `markets-overview/${selectedDate}`,
  );
  return data;
};

export type GetYieldCurveParams = {
  currency: string;
  curve: string;
  positionDate: string;
};

/** GET /yield-curve/:currency/:curve/:positionDate — yield curve (`PageModel` envelope). */
export const getYieldCurve = async ({
  currency,
  curve,
  positionDate,
}: GetYieldCurveParams): Promise<YieldCurvePageModel> => {
  const { data } = await AxiosInstance.get<YieldCurvePageModel>(
    `yield-curve/${currency}/${curve}/${positionDate}`,
  );
  return data;
};
